<template>
    <div class="row">
        <or-select
            class="feature-selection"
            v-model="localSelectedFeatures"
            :label="$t('model.nlu-model.sidebar.entities.editors.ml-entity.ml-features-selection.features')"
            :placeholder="$t('model.nlu-model.sidebar.entities.editors.ml-entity.ml-features-selection.selectFeatures')"
            :options="featureOptions"
            :disabled="isLoading"
            multiple
        />
    </div>
</template>

<script>
export default {
  name: 'ml-features-selector',
  props: {
    features: Array,
    // https://gitlab.com/onereach/platform/nlu/nlu-api/-/blob/phrases/1.1832/117/lib/schemas/joi/simple_phrases.js
    selectedFeatures: Array,
    isLoading: Boolean
  },

  computed: {
    featureOptions () {
      return this.$props.features.map(feature => ({
        label: feature.name,
        value: feature.name
      }))
    },

    localSelectedFeatures: {
      get () {
        return this.$props.selectedFeatures.map(feature => feature.featureName)
      },
      set (features) {
        const selectedFeatures = features.map(feature => ({
          featureName: feature,
          isRequired: false
        }))
        this.$emit('update:selected-features', selectedFeatures)
      }
    }
  }
}
</script>

<style scoped>

</style>
